import React from 'react';
import { IntygsAnsokan, IFolkbokforingsAdress, IKeyValue } from './ansokan.types';
import { FormType, ApplicationType } from './Intyg.enums';
import { FormField } from 'sos-common/js/commonTypes/formField.types';
import { SelectBoxOption } from 'sos-common/js/components/FormControls/SelectBox';

export interface IAppContext {
  Translate: (key: string, defaultValue?: string) => string;
  updateModelUsingKeyValue: (key: string, value: any, callback?: () => void) => void;
  updateModelAsBatch: (arr: IKeyValue[], callback?: () => void) => void;
  onChangeFieldValue: (field: FormField<any>, callback?: () => void) => void;
  onChangeCheckboxGroupValue: (field: FormField<string[]>) => void;
  forceComponentTreeReRender: () => void;
  onClickSubmitButton: (isFormValid: boolean) => void;
  submitButtonIsClicked: boolean;
  applicationType: ApplicationType;
  formType: FormType;
  model: IntygsAnsokan;
  bekraftaepost?: string;
  editableAreas: IKeyValue[];
  isInEditMode: boolean;
  ansokanId?: number;
  yrken: SelectBoxOption[];
  folkbokforing?: IFolkbokforingsAdress;
  isAdressuppgifterVisible?: boolean;
  thankYouPage?: string;
  stepTwoPageLink?: string;
  clientKey?: string;
  maxTotalSizeInBytes: number;
  myPageLink?: string;
  contentId: number;
  yrkeSpecificInformationBoxes?: Map<string, string>;
  showSpinner: boolean;
  maxIndividualFileSizeInBytes?: number;
  formLanguage: string;
  setSubmitButtonAsClicked: (callback?: () => void) => void;
  isFormTouched?: boolean;
  acceptedFileTypes: string[];
}

export interface ValidationError {
  errorMessage: string;
  showMessage: boolean;
}

export interface IFormStateBase {
  isFormValid: boolean;
}

export interface PostFilesServerResponseObject {
  FileId: string;
  kompletteringId?: string;
  OriginalFilename?: string;
}

export const AppContext = React.createContext<IAppContext>(null);
